import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { create } from 'zustand';

//  create a asp zustand store
interface ASPStore {
  type: string;
  isConnected: boolean;
  isInit: boolean;
  code: string;
  aspUrl: string;
  domain: string;
  isFullLayout: boolean;
  isFullScreen: boolean;
  isFsSupport: boolean;
  height: number;
  config: unknown;
  scrollTop: number;
  bottom: number;
  bottomPadding: number;
  iframeHeight: number; // 추가
  viewportHeight: number; // 실제 보이는 영역 높이 추가
  update: (data: Partial<ASPStore>) => void;
  isRecommand: boolean;
}
export const useASPStore = create<ASPStore>()(set => ({
  height: 0,
  scrollTop: 0,
  type: 'popup',
  isConnected: false,
  isInit: false,
  code: '',
  aspUrl: '',
  domain: '',
  isFullLayout: false,
  isFullScreen: false,
  isFsSupport: false,
  config: null,
  iframeHeight: 0,
  // 추가
  viewportHeight: 0,
  // 추가
  bottom: 0,
  bottomPadding: 0,
  isRecommand: false,
  update: (data: Partial<ASPStore>) => set(state => ({
    ...state,
    ...data
  }))
}));

// iframe-asp 환경에서 하단 고정 요소의 위치를 계산하기 위한 공용 훅
// baseBottomPx: 기존에 하단 여백이 있는 경우(예: bottom-14 = 56px) 더해줄 값
export function useIframeAspFixedBottomStyle(t0, enabled) {
  const $ = _c(2);
  const baseBottomPx = t0 === undefined ? 0 : t0;
  const {
    scrollTop,
    viewportHeight,
    iframeHeight,
    height
  } = useASPStore(_temp);
  if (!enabled) {
    return;
  }
  let expectedIframeHeight = iframeHeight;
  if (iframeHeight - 100 === height) {
    expectedIframeHeight = height;
  }
  const iframeBottom = Math.max(expectedIframeHeight - (scrollTop + viewportHeight), 0);
  const t1 = `${iframeBottom + baseBottomPx}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: t1,
      transform: "none"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2 as React.CSSProperties;
}
function _temp(s) {
  return {
    scrollTop: s.scrollTop,
    viewportHeight: s.viewportHeight,
    iframeHeight: s.iframeHeight,
    height: s.height
  };
}